/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Users_Manage_RolesInputs */

const en_admin_users_manage_roles = /** @type {(inputs: Admin_Users_Manage_RolesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage Roles`)
};

const zh_admin_users_manage_roles = /** @type {(inputs: Admin_Users_Manage_RolesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理角色`)
};

/**
* | output |
* | --- |
* | "Manage Roles" |
*
* @param {Admin_Users_Manage_RolesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_users_manage_roles = /** @type {((inputs?: Admin_Users_Manage_RolesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Users_Manage_RolesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_users_manage_roles(inputs)
	return zh_admin_users_manage_roles(inputs)
});
export { admin_users_manage_roles as "admin.users.manage_roles" }